import React, { useState } from "react";
import { Modal, Form, TimePicker, Input, Button, message, Divider } from "antd";
import dayjs from "dayjs";
import { updateNurseCommonData } from "../../../services/nurse.services";
import useIsMobile from "../../../hooks/useIsMobile";
import { NURSE_IP_COMPACT_MODAL_WRAP } from "../../IpEMR/Doctor/InitialInspection/ClosePopup";
import { releaseNurseMobileScrollLock } from "./releaseNurseMobileScrollLock";
import "./NurseMedicine.css";

const format = "hh:mm A";
const StatMedicineModal = ({
  open,
  setOpen,
  frequency,
  actions,
  refreshPage,
}) => {
  const isMobile = useIsMobile();
  const [selectedTime, setSelectedTime] = useState(new Date().toISOString());

  const getDisabledTime = () => {
    const now = dayjs();

    return {
      disabledHours: () => {
        const hours = [];
        for (let i = now.hour() + 1; i < 24; i++) {
          hours.push(i);
        }
        return hours;
      },

      disabledMinutes: (selectedHour) => {
        if (selectedHour === now.hour()) {
          const minutes = [];
          for (let i = now.minute() + 1; i < 60; i++) {
            minutes.push(i);
          }
          return minutes;
        }
        return [];
      },

      disabledSeconds: () => [],
    };
  };

  const onFinish = (values) => {
    if (actions?.[0]?.is_stopped === true) {
      message.warning("This medicine has been stopped and cannot be updated.");
      return;
    }

    const updatedMedicine = {
      process_time: selectedTime,
      action: "done",
      remarks: values?.remarks,
    };
    const sosMedicines = actions?.[0]?.nurse_data
      ? [...actions?.[0]?.nurse_data, updatedMedicine]
      : [updatedMedicine];
    const formData =
      frequency === "Immediately"
        ? { action: "done", nurse_data: [updatedMedicine] }
        : { nurse_data: sosMedicines };

    updateNurseCommonData(actions?.[0]?.id, formData)
      .then((res) => {
        message.success(res.data.message);
        refreshPage();
        setOpen(false);
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenChange = (isOpen) => {
    if (!isOpen && isMobile) {
      releaseNurseMobileScrollLock();
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onCancel={handleClose}
        afterOpenChange={handleOpenChange}
        footer={null}
        className="nurse-med-time-done-modal"
        {...(isMobile && {
          centered: true,
          wrapClassName: NURSE_IP_COMPACT_MODAL_WRAP,
          getContainer: () => document.body,
          width: "calc(100vw - 32px)",
          destroyOnClose: true,
        })}
      >
        <Form layout="vertical" onFinish={onFinish} className="nurse-med-time-done-form">
          <Form.Item
            label={<span style={{ fontWeight: "600" }}>Time Done</span>}
            name="process_time"
            initialValue={dayjs(selectedTime)}
          >
            <Divider />
            <TimePicker
              inputReadOnly
              needConfirm={false}
              format={format}
              value={dayjs(selectedTime)}
              onChange={(date) => setSelectedTime(date)}
              disabledTime={getDisabledTime}
            />
          </Form.Item>
          <Form.Item label="Remarks" name="remarks">
            <Input.TextArea />
          </Form.Item>
          <Divider />

          <Form.Item style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default StatMedicineModal;
